module.exports = __webpack_public_path__ + "img/75984.d7e786db.svg";